export const baseUrl = __BASE_URL__;
export const publicUrl = __PUBLIC_URL__;
export const criptoKey = __KEY__;
export const cookiePath = __COOKIE_PATH__;

const API_VERSION  = `/v1`
export const apiUrls = Object.freeze({
  refreshToken: `${API_VERSION}/refresh`,
  checkAccessToken: `${API_VERSION}/token`,
  login: `${API_VERSION}/login`,
  tenancyList: `${API_VERSION}/tenants`,
  tenancyById: `${API_VERSION}/tenancies/company/:id`,
  updateTenancyById: `${API_VERSION}/tenancies/company/:id`,
  createTenancy: `${API_VERSION}/tenancies`,

  reportAccDeposits: `${API_VERSION}/reports/account-deposits?`,
  reportFinalAmount: `${API_VERSION}/reports/final-amount?`,

  saveTenancyLang: `${API_VERSION}/tenancies/language/:id`,
  getTenancyLang: `${API_VERSION}/tenancies/language/:id`,
  getTenancyMccList: `${API_VERSION}/tenancies/language/:id`,
  getSAASMccList: `${API_VERSION}/tenancies`,
  addGoogleMcc: `${API_VERSION}/tenancies/company/:id`,

  getTenancyGoogleCreditLine: `${API_VERSION}/tenancies/language/:id`,
  setTenancyGoogleApi: `${API_VERSION}/tenancies/language/:id`,
  setTenancyGoogleCreditLine: `${API_VERSION}/tenancies/language/:id`,
  setTenancyGoogleTag: `${API_VERSION}/tenancies/language/:id`,

  getTenancyFacebookCreditLine: `${API_VERSION}/tenancies/language/:id`,
  setTenancyFacebookCreditLine: `${API_VERSION}/tenancies/language/:id`,
  setTenancyFacebookApi: `${API_VERSION}/tenancies/language/:id`,

  getTenancyTikTokCreditLine: `${API_VERSION}/tenancies/language/:id`,
  setTenancyTikTokCreditLine: `${API_VERSION}/tenancies/language/:id`,
  setTenancyTikTokApi: `${API_VERSION}/tenancies/language/:id`,

  setTenancyYandexApi: `${API_VERSION}/tenancies/language/:id`,
  setTenancyYandexCreditLine: `${API_VERSION}/tenancies/language/:id`,
  getTenancyYandexCreditLine: `${API_VERSION}/tenancies/language/:id`,

  getTenancyApiGateToken: `${API_VERSION}/tenancies/language/:id`,
  setTenancyApiGateToken: `${API_VERSION}/tenancies/language/:id`,
  getTenancyServicesList: `${API_VERSION}/tenants/services`,

  getIndividualCommissions: `${API_VERSION}/commissions/individual`,
  getGeneralCommissions: `${API_VERSION}/commissions/general`,
  deleteCommission: `${API_VERSION}/commissions/delete/:id`,
  updateCommission: `${API_VERSION}/commissions/update`,
  createCommission: `${API_VERSION}/commissions/individual/create`,
  getClientCommissionList: `${API_VERSION}/commissions/no-individual`,
  updateStataUrl: `${API_VERSION}/clients/into-cabinet/auth-code/:id`,

  getDemoCabinetClientList:`${API_VERSION}/demo-cabinet/cabinets`,
  saveDemoDataUrl: `${API_VERSION}/demo-cabinet/generate`,

  logout: `${API_VERSION}/app/logout`,
  getMenuUrl: `${API_VERSION}/menu`,
  getMenuInformer: `${API_VERSION}/sidebar/informants`,
  fullAccList: `${API_VERSION}/ad-account/all`,
  clientsAccList: `${API_VERSION}/clients/card/accounts/:id`,
  setProviderUrl: `${API_VERSION}/ad-account/setup-account-provider`,
  createProviderUrl: `${API_VERSION}/provider/create`,
  archivedAccUrl: `${API_VERSION}/ad-account/setup-account`,
  googleImport: `${API_VERSION}/google/import`,
  ttImport: `${API_VERSION}/tik-tok/import`,
  yaImport: `${API_VERSION}/yandex/import`,
  businessTTCenter: `${API_VERSION}/tik-tok/center/all`,
  businessYACenter: `${API_VERSION}/yandex/center/all`,
  importFbUrl: `${API_VERSION}/facebook/import`,
  hideAccUrl: `${API_VERSION}/ad-account/hide`,
  getClientInfoUrl: `${API_VERSION}/clients/card/info/:id`,
  getManualOperationClients: `${API_VERSION}/clients/all-manual-fin-management`,
  clientsForGoogleImport: `${API_VERSION}/clients/import-account?hasMcc=true`,
  clientsForFbImport: `${API_VERSION}/clients/import-account`,
  teamListUrl: `${API_VERSION}/teams/list`,
  deleteTeamUrl: `${API_VERSION}/teams/delete/:id`,
  updateTeamUrl: `${API_VERSION}/teams/update/:id`,
  createTeamUrl: `${API_VERSION}/teams/create`,
  checkUniqTeamNameUrl: `${API_VERSION}/teams/check-unique-name?name=:name`,
  getSentinelDataUrl: `${API_VERSION}/users/sentinels`,
  getTeamLeadsListUrl: `${API_VERSION}/users/team-leads`,
  getSupportClientsList: `${API_VERSION}/clients`,
  setClientOL: `${API_VERSION}/clients/switch-open-line/:id`,
  goToSupportCabinet: `${API_VERSION}/clients/into-cabinet/auth-code/:id`,
  goToSalesCabinet: `${API_VERSION}/sales/into-cabinet/auth-code/:id`,
  getClientsList: `${API_VERSION}/clients/card/clients/:id`,
  getManagementTags: `${API_VERSION}/tags/management/list`,
  setClientsFinParam: `${API_VERSION}/clients/finance_management/:id`,
  setManagerTag: `${API_VERSION}/clients/switch-management-tag/:id`,
  createManagementTag: `${API_VERSION}/tags/management/create`,
  changeExpense: `${API_VERSION}/clients/card/expense/expectation`,
  getExpenseHistory: `${API_VERSION}/clients/card/expense/month/:clientId?dateFrom=:dateFrom&dateTo=:dateTo`,
  getExpenseList: `${API_VERSION}/clients/card/expense/:id`,
  importedAccList: `${API_VERSION}/ad-account/for-import?serviceType=:serviceType`,
  adAccImport: `${API_VERSION}/ad-account/import`,
  finDocList: `${API_VERSION}/documents/fin/all/:dateFrom/:dateTo`,
  clientFinDocsList: `${API_VERSION}/clients/card/documents/get/all/:id?dateFrom=:dateFrom&dateTo=:dateTo`,
  getReconciliationActUrl: `${API_VERSION}/clients/card/documents/get-reconciliation-act/:clientId?beginDate=:beginDate&endDate=:endDate&withSignature=false`,
  getPostPaymentPrevFile: `${API_VERSION}/post-payment-documents/load/file/:clientId`,
  getBonusInfoFile: `${API_VERSION}/bonus-documents/load/file/:cabinetId/:bonusEnrollmentId`,
  preRegGetTemplate: `${API_VERSION}/pre-registration/template`,
  preRegGetClientList: `${API_VERSION}/pre-registration/export`,
  preRegGetResultFile: `${API_VERSION}/bonus-documents/load/file/:cabinetId/:bonusEnrollmentId`,
  clients: `${API_VERSION}/clients/get-all-clients`,
  clientsActivity: `${API_VERSION}/clients/client-summaries`,
  countries: `${API_VERSION}/country/en/all`,
  exchangeRateReport: `${API_VERSION}/currency/history?currencyFrom=:currencyFrom&currencyTo=:currencyTo&dateFrom=:dateFrom&dateTo=:dateTo`,
  getTikTokRequests: `${API_VERSION}/tik-tok/registration/all`,
  TikTokUpdateRegistration: `${API_VERSION}/tik-tok/registration/update`,
  changeTikTokStatus: `${API_VERSION}/tik-tok/registration/change-status/:id/:status`,
  deleteTikTokRequest: `${API_VERSION}/tik-tok/registration/delete/:id`,
  ttRequestRevisionUrl: `${API_VERSION}/tik-tok/registration/revision`,
  ttThemes: `${API_VERSION}/tik-tok/all/themes`,
  ttTimezone: `${API_VERSION}/tik-tok/all/time-zone`,
  createTikTokAcc: `${API_VERSION}/tik-tok/registration/create-account`,
  giveAccessToTTAcc: `${API_VERSION}/tik-tok/registration/create-finish/:id`,
  getScreeningList: `${API_VERSION}/premoderation/get`,
  // getScreeningByUserId: `/screening/get/:userId`,
  getScreeningByUserId: `${API_VERSION}/premoderation/get/:userId`,
  getFilesForScreening: `${API_VERSION}/screening/load/file/:fileName/:userId`,
  savePostPayCalculation: `${API_VERSION}/post-payment-documents/save/:id/:date`,
  getLastPostPaymentData: `${API_VERSION}/post-payment-documents/get/:id`,
  updateScreeningStatus: `${API_VERSION}/premoderation/update`,
  getSalesClients: `${API_VERSION}/sales/replenish/clients`,
  getLeadListUrl: `${API_VERSION}/sales`,
  approveSalesPL: `${API_VERSION}/sales/pay-line/approve/:id`,
  getSalesPLInfoById: `${API_VERSION}/sales/pay-line/:id`,
  getApibaInfo: `${API_VERSION}/sales/pay-line/by-bin/:id`,
  getSalesPL: `${API_VERSION}/sales/pay-line`,
  salesManualReplenish: `${API_VERSION}/sales/replenish`,
  salesPLReject: `${API_VERSION}/sales/pay-line/reject/:id`,
  getPaymentsList: `${API_VERSION}/payment/dashboard/payments/all`,
  getInvoicesList: `${API_VERSION}/payment/dashboard/invoices/all`,
  setPaymentsComment: `${API_VERSION}/payment/dashboard/payment/comment/:id`,
  getInvoiceById: `${API_VERSION}/payment/dashboard/invoices/short/:id`,
  getPaymentsById: `${API_VERSION}/payment/dashboard/payments/all/short/:id`,
  linkedPaymentInvoice: `${API_VERSION}/payment/dashboard/link`,
  paymentRefresh: `${API_VERSION}/payment/dashboard/payment/refresh/:id`,
  paymentInvoiceHide: `${API_VERSION}/payment/dashboard/hide/`,
  changeEmailUrl: `${API_VERSION}/clients/provide-client-access`,
  setInvoice: `${API_VERSION}/payment/invoice/create`,
  getClientInvoice: `${API_VERSION}/payment/invoice/get`,
  getPayLineList: `${API_VERSION}/pay-line/primary-mod`,
  payLineApprove: `${API_VERSION}/pay-line/primary-mod/approve/:id`,
  payLineApproveOld: `${API_VERSION}/pay-line/primary-mod/approve/:id`,
  payLineReject: `${API_VERSION}/pay-line/primary-mod/reject/:id`,
  getPLById: `${API_VERSION}/pay-line/primary-mod/:id`,
  getPLModerationById: `${API_VERSION}/pay-line/post-mod/:id`,
  getSalesPLById: `${API_VERSION}/sales/pay-line/:id`,
  getSalesCommissions: `${API_VERSION}/pay-line/primary-mod/:id`,
  updatePL: `${API_VERSION}/pay-line/primary-mod/update/:id`,
  getModerationPL: `${API_VERSION}/pay-line/post-mod`,
  approveModerationPL: `${API_VERSION}/pay-line/post-mod/approve/:id`,
  toServiceAccess: `${API_VERSION}/cabinet-services/to-service-access`,
  getClientServiceAccess: `${API_VERSION}/cabinet-services/to-service-access/:id`,
  rejectModerationPL: `${API_VERSION}/pay-line/post-mod/reject/:id`,
  getMiddleMcc: `${API_VERSION}/google/mcc/middle-mcc`,
  createMcc: `${API_VERSION}/google/mcc/add`,
  getAvailableMcc: `${API_VERSION}/google/mcc/available`,
  getAssignedMcc: `${API_VERSION}/google/mcc/assigned`,
  closeWebsocket: `${API_VERSION}/websocket/close-session/:sessionId`,
  getPartnerProgramRequestsList: `${API_VERSION}/partner_program/request`,
  getPartnerProgramClientsList: `${API_VERSION}/partner_program/clients`,
  changePartnerProgramStatus: `${API_VERSION}/partner_program/request/update`,
  setPermissionsCC: `${API_VERSION}/pay-line/primary-mod/consent/:id`,
  changeStatusPL: `${API_VERSION}/pay-line/primary-mod/checking/:id`,
  changeSalesStatusPL: `${API_VERSION}/sales/pay-line/checking/:id`,
  getCommissionsForClient: `${API_VERSION}/commissions/:id`,
  getProvidersList: `${API_VERSION}/provider`,
  getProvidersListByServiceType: `${API_VERSION}/provider?serviceType=:serviceType`,
  createProviderURL: `${API_VERSION}/provider/create`,
  updateProviderURL: `${API_VERSION}/provider/update`,
  specializationsList: `${API_VERSION}/adverton-partners/specializations`,
  createAdvPartner: `${API_VERSION}/adverton-partners/create`,
  deleteAdvPartner: `${API_VERSION}/adverton-partners/delete/:id`,
  updateAdvPartner: `${API_VERSION}/adverton-partners/update/:id`,
  advPartnerList: `${API_VERSION}/adverton-partners`,
  bonusCCList: `${API_VERSION}/bonus-program/center-clients`,
  CCBonusTerms: `${API_VERSION}/bonus-program/terms/:id`,
  getClientsInfo: `${API_VERSION}/pay-line-validation/check-bin`,
  getBankListUrl: `${API_VERSION}/system/bank-list`,
  bonusCreate: `${API_VERSION}/bonus-program/terms`,
  checkBinExist: `${API_VERSION}/pay-line-validation/check-tax-id`,
  createClientUrl: `${API_VERSION}/clients/create`,
  bonusProgramList: `${API_VERSION}/bonus-program`,
  bonusCList: `${API_VERSION}/bonus-program/clients`,
  updateBP: `${API_VERSION}/bonus-program/terms`,
  deleteBP: `${API_VERSION}/bonus-program/exclude`,
  includeBP: `${API_VERSION}/bonus-program/include`,
  bonusListForManualReplenish: `${API_VERSION}/clients/available-for-bonus`,
  enrollmentBonus: `${API_VERSION}/manual_replenishment/bonus`,
  bonusFileSave: `${API_VERSION}/bonus-documents/save/:cabinetId/:bonusId`,
  preRegUploadFile: `${API_VERSION}/pre-registration/upload`,
  bonusFileDelete: `${API_VERSION}/bonus-documents/delete/:cabinetId`,
  generateBonusReport: `${API_VERSION}/preliminary_report?from=:from`,
  getGeoTTReport: `${API_VERSION}/reports/tik-tok/geo?from=:from&to=:to`,
  getClientTransactions: `${API_VERSION}/clients/card/transactions/:id?from=:from&to=:to`,
  getGateTransactions: `${API_VERSION}/transactions-gate?from=:from&to=:to`,
  manualReplenishUrl: `${API_VERSION}/manual_replenishment?from=:from&to=:to`,
  manualReplenishInvoiceUrl: `${API_VERSION}/manual_replenishment/manual`,
  manualReplenishOtherUrl: `${API_VERSION}/manual_replenishment/other`,
  manualDeductListUrl: `${API_VERSION}/manual_deduct/all?from=:from&to=:to`,
  operationsDetailsListUrl: `${API_VERSION}/manual_deduct/all?from=:from&to=:to`,
  setManualDeductUrl: `${API_VERSION}/manual_deduct`,
  clientsManualDeductUrl: `${API_VERSION}/clients/manual-debiting`,
  manualPenaltyListUrl: `${API_VERSION}/fines/policy-fines?from=:from&to=:to`,
  getGoogleTaxUrl: `${API_VERSION}/account-taxes/?from=:from&to=:to`,
  getGooglePreviewUrl: `${API_VERSION}/account-taxes/preview?date=:date`,
  setPenaltyUrl: `${API_VERSION}/fines/levy`,
  getPenaltyClients: `${API_VERSION}/clients/for-fine?serviceType=:serviceType&blockedOnly=:flag`,
  getPenaltyAccounts: `${API_VERSION}/ad-account/for-fine?cabinetId=:cabinetId&serviceType=:serviceType&blockedOnly=:flag`,
  getAPUsers: `${API_VERSION}/users/all`,
  setActivateUser: `${API_VERSION}/users/activate/:id`,
  setADeactivateUser: `${API_VERSION}/users/deactivate/:id`,
  checkEmail: `${API_VERSION}/users/check-email`,
  createUser: `${API_VERSION}/users/create`,
  updateUserUrl: `${API_VERSION}/users/update`,
  getFBListUrl: `${API_VERSION}/facebook/registration/get-accounts`,
  fbRevision: `${API_VERSION}/facebook/registration/status/revision/:id`,
  fbAddId: `${API_VERSION}/facebook/add-account-id`,
  fbTimeZone: `${API_VERSION}/time-zone/all`,
  fbUpdateUrl: `${API_VERSION}/facebook/registration/update`,
  processFB: `${API_VERSION}/facebook/registration/status/process/:id`,
  newFB: `${API_VERSION}/facebook/registration/status/new/:id`,
  delFb: `${API_VERSION}/facebook/registration/delete/:id`,
  countryList: `${API_VERSION}/country/en/all`,
  getFinDocAct: `${API_VERSION}/payment/act/get`,
  getFinDetailsByIdUrl: `${API_VERSION}/transactions-gate/:id/details`,
  // handleChangeOperation: `/transactions-gate/:transactionId/status?success=:status`,
  getAccInvoiceDataUrl: `${API_VERSION}/account-taxes/update/`,
  handleChangeOperation: `${API_VERSION}/transactions-gate/:transactionId/:status/close`,
  closeOperationUrl: `${API_VERSION}/transactions-gate/:transactionId/close`,
  updateOperationUrl: `${API_VERSION}/transactions-gate/:id`,
});

export const appUrls = Object.freeze({
  demoCabinet:`/demo-cabinet`,
  clientList: `/clients/client-list`,
  leadList: `/clients/lead-list`,
  clientsActivity: `/clients/accounts-active`,
  clients: `clients`,
  login: `/login`,
  partnerProgram: `/partnership-program`,
  partnerProgramTerms: `/partnership-program/terms`,
  partnerProgramRequests: `/partnership-program/requests`,

  bonusProgram: `/bonuses`,
  bonusProgramTerms: `/bonuses/bonus_terms`,
  bonusProgramReport: `/bonuses/bonus_preliminary_report`,
  adAccount: `/addAccount`,
  providers: `/providers`,
  facebookReg: `/requestFB`,
  tikTokReg: `/requestTikTok`,
  PLPostVerification: `/payment_info`,

  PLVerification: `/pay-line-primary`,
  verifyPayLine: `/pay-line-primary/payers`,
  verifySalesPayLine: `/pay-line-primary/sales-pl`,
  googleMcc: `/mccGoogleAds`,

  operationClosing: `/transaction_requests`,

  manualTransactions: `/manual-transactions`,
  manualPayment: `/manual-transactions/manual-payment`,
  manualDebiting: `/manual-transactions/manual-deduct`,
  manualPenalty: `/manual-transactions/penalty`,

  commissions: `/commissions`,
  commissionsIndividual: `/commissions/individual`,
  commissionGeneral: `/commissions/general`,

  finDocs:`/financial`,
  paymentProblems: `/financial/invoice_payments`,
  competitionCertificate: `/financial/fin-docs`,

  usersItem: `/users`,
  users: `/users/users-list`,
  projectsAccesses: `/users/teams`,

  reportsItem: `/reports`,
  reports: `/reports/reports-list`,
  exchangeRate: `/reports/rate`,
  googleTax: `/google-tax`,
  preModeration: `/screening`,
  advPartners: `/adv-partner`,
  // sentinel:`sentinel`,


  saas: `/saas`,

  saasTenancy: `/saas/tenancy`,
  saasGoogleAds: `/saas/googleMCC`,
  addTenancy: `/saas/tenancy/create`,
  tenancySettings: `/saas/tenancy/settings`,
  tenancySettingsCompany: `/saas/tenancy/settings/:id/company`,
  tenancySettingsAdSystems: `/saas/tenancy/settings/:id/ad_systems`,
  tenancyAdSystemsGoogleCreditLine: `/saas/tenancy/settings/:id/ad_systems/1/credit_line`,
  tenancyAdSystemsFacebookCreditLine: `/saas/tenancy/settings/:id/ad_systems/3/credit_line`,
  tenancyAdSystemsTikTokCreditLine: `/saas/tenancy/settings/:id/ad_systems/4/credit_line`,
  tenancyAdSystemsYandexCreditLine: `/saas/tenancy/settings/:id/ad_systems/5/credit_line`,
  tenancyAdSystemsApiGate: `/saas/tenancy/settings/:id/ad_systems/api_gate`,
  tenancyAdSystemsServiceCreditLine: `/saas/tenancy/settings/:id/ad_systems/:serviceType/credit_line`,
  tenancyAdSystemsGoogleClientTag: `/saas/tenancy/settings/:id/ad_systems/1/client_tag`,
  tenancyAdSystemsGoogleApi: `/saas/tenancy/settings/:id/ad_systems/1/api`,
  tenancyAdSystemsServiceClientTag: `/saas/tenancy/settings/:id/ad_systems/:serviceType/client_tag`,
  tenancyAdSystemsServiceApi: `/saas/tenancy/settings/:id/ad_systems/:serviceType/api`,
  tenancyAdSystemsFacebookApi: `/saas/tenancy/settings/:id/ad_systems/3/api`,
  tenancyAdSystemsTikTokApi: `/saas/tenancy/settings/:id/ad_systems/4/api`,
  tenancyAdSystemsYandexApi: `/saas/tenancy/settings/:id/ad_systems/5/api`,
  tenancySettingsLanguage: `/saas/tenancy/settings/:id/language`,
  screening: `/screening`,
  screeningId: `/screening/:id`,
  requestTikTok: `/requestTikTok`,
  paymentInfo: `/payment_info`,
  payers: `/payers`,
  salesPayers: `/payers-sales`,
  payersId: `/payers/:id`,
  partnerProgramClients: `/partnership-program/clients`,
  createClient: `/create-client`,
  clientExpenses: `/client/:id/expenses`,
  clientPayLine: `/client/:id/payline`,
  clientAccounts: `/client/:id/accounts`,
  postPayCalculation: `/client/:id/postPayCalculation`,
  clientSettings: `/client/:id/settings`,
  clientInfo: `/client/:id/info`,
  CCClientsList: `/client/:id/client_list`,
  clientFinMovement: `/client/:id/finMovement`,
  clientContracts: `/client/:id/contracts`,
  clientFinDocs: `/client/:id/finDoc`,
  clientProfitability: `/client/:id/profitability`,
  clientClientsPage: `/client/:id/clients`,
  clientFinSettings: `/client/:id/finSettings`,
  reportsRate: `/reports/rate`,

  penalty: `/penalty`,
  teams: `/teams`,
  finWrap: `/financial`,
  invoicePayments: `/financial/invoice_payments`,
  advPartner: `/adv-partner`,
  system: `/system`,

  bonusPreliminaryReport: `/bonus_preliminary_report`

})